import { ArrowRightOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { Link } from 'react-router-dom';
import gamaLogo from '../../../Assets/images/gamamobility-logo_vert-n.svg';
import { HOME_ROUTE } from '../../../Components/Router/constant';
import './header.scss';

type Props = {};

export const LandingHeaderComponent = (props: Props) => {
  return (
    <div className="landing-header-component">
      <div className="landing-header">
        <Row justify="center">
          <Col span={24} className="content">
            <img src={gamaLogo} alt="Gama Mobility" style={{ height: 48, width: "auto" }} />
            <div className="content_right">
              <strong
                style={{
                  color: '#22B260',
                }}
              >
                ¿Qué se necesita para declarar un siniestro?
              </strong>
              <span>Protocolo en caso de siniestro</span>
            </div>
          </Col>
        </Row>
      </div>

      <div className="introduction">
        <Row justify="center" style={{ paddingBottom: '10px' }}>
          <Col span={20} className="welcome-message">
            Te damos la bienvenida <br /> al portal de seguros y siniestros
          </Col>
          <Col span={20} className="introduction-message">
            En el portal podrás: declarar siniestro, hacer seguimiento, notificar robo total del vehículo y generar reclamos como terceros.
          </Col>

          <Col span={20}>
            <div className="ingresarAlPortal">
              <Link className="btn" to={HOME_ROUTE}>
                Ingresar al portal <ArrowRightOutlined />
              </Link>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};
